import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CHILD_PROPS_TO_USE } from '../constants';
const buildChildProps = (childProps, parentProps) => {
  const propsToOverride = {};
  CHILD_PROPS_TO_USE.forEach(prop => propsToOverride[prop] = childProps[prop]);
  return _objectSpread(_objectSpread({}, parentProps), propsToOverride);
};
const renderChildren = (children, otherProps = {}) => React.Children.map(children, child => {
  const childrenElements = child.props.children;
  if (Array.isArray(childrenElements) && childrenElements.length) {
    const [, nestedChildren] = child.props.children;
    return Array.isArray(nestedChildren) && nestedChildren.map(nestedChild => renderChildren(nestedChild, otherProps));
  }
  const childProps = buildChildProps(child.props, otherProps);
  return React.cloneElement(child, _objectSpread({}, childProps));
});
export default renderChildren;
//# sourceMappingURL=render-children.js.map